import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  addAttachment,
  attachmentDefaultState,
  AttachmentState,
  removeAttachment,
  replaceAttachment,
} from './common/FileUploadReducers';
import {
  addFileToUploadTracker,
  fileUploadStatusDefaultState,
  FileUploadStatusState,
  removeFileFromUploadTracker,
  setFileToError,
  setFileToUploadComplete,
} from 'src/state/slice/common/FileUploadStatusReducers';
export interface AddCorrespondenceState
  extends AttachmentState,
    FileUploadStatusState {
  textContent: string;
  displayOnPublicPortal: boolean;
  attachmentValidationError: string | null;
}

const initialState: AddCorrespondenceState = {
  textContent: '',
  displayOnPublicPortal: false,
  attachmentValidationError: null,
  ...attachmentDefaultState,
  ...fileUploadStatusDefaultState,
};

export const addCorrespondenceSlice = createSlice({
  name: 'addCorrespondence',
  initialState,
  reducers: {
    reset: () => initialState,
    addAttachment,
    removeAttachment,
    replaceAttachment,

    addFileToUploadTracker,
    setFileToUploadComplete,
    removeFileFromUploadTracker,
    setFileToError,

    addTextContent: (state, actions) => {
      state.textContent = actions.payload;
    },

    setDisplayOnPublicPortal: (state, actions) => {
      state.displayOnPublicPortal = actions.payload;
    },

    setAttachmentValidationError: (state, actions: PayloadAction<string>) => {
      state.attachmentValidationError = actions.payload;
    },

    clearAttachmentValidationError: (state) => {
      state.attachmentValidationError = null;
    },
  },
});

export const {
  addTextContent,
  reset,
  setDisplayOnPublicPortal,
  setAttachmentValidationError,
  clearAttachmentValidationError,
} = addCorrespondenceSlice.actions;
export default addCorrespondenceSlice.reducer;
